
import React, { useState } from 'react';
import './PublicationModalForm.scss';
import { publicationTags } from '../../config/publicationTags';


export default function PublicationModalForm({
  open,
  mode = 'upload', // 'upload' or 'edit'
  initialValues = {},
  onSubmit,
  onClose,
  uploading,
  error,
}) {
  const [title, setTitle] = useState(initialValues.title || '');
  const [description, setDescription] = useState(initialValues.description || '');

  const [outlooks, setOutlooks] = useState(initialValues.outlooks || []);
  const [publishDate, setPublishDate] = useState(initialValues.publishDate || '');
  const [file, setFile] = useState(null);

  React.useEffect(() => {
    setTitle(initialValues.title || '');
    setDescription(initialValues.description || '');
    setOutlooks(initialValues.outlooks || []);
    setPublishDate(initialValues.publishDate || '');
    setFile(null);
  }, [initialValues, open]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, description, outlooks, publishDate, file });
  };

  return (
    <div className="publication-modal-overlay">
      <div className="publication-modal">
        <h2>{mode === 'edit' ? 'Edit Publication' : 'Upload Publication'}</h2>
        {error && <div className="modal-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <label>
            Title:
            <input type="text" value={title} onChange={e => setTitle(e.target.value)} maxLength={200} />
          </label>
          <label>
            Description:
            <textarea value={description} onChange={e => setDescription(e.target.value)} maxLength={1000} />
          </label>
          <label>
            Publish Date:
            <input type="date" value={publishDate} onChange={e => setPublishDate(e.target.value)} />
          </label>
          <label>
            Tag(s):
            <div
              className="outlooks-checkbox-group"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: '4px',
                marginBottom: '8px',
              }}
            >
              {publicationTags.map(({ id, label }) => (
                <label
                  key={id}
                  style={{ display: 'flex', alignItems: 'center', padding: '4px 0', marginBottom: 0 }}
                >
                  <input
                    type="checkbox"
                    value={id}
                    checked={outlooks.includes(id)}
                    onChange={e => {
                      if (e.target.checked) {
                        setOutlooks([...outlooks, id]);
                      } else {
                        setOutlooks(outlooks.filter(o => o !== id));
                      }
                    }}
                    style={{ marginRight: '8px' }}
                  />
                  {label}
                </label>
              ))}
            </div>
          </label>
          <label>
            {mode === 'edit' ? 'Replace File:' : 'File:'}
            <input
              type="file"
              accept=".pdf,.xlsx,.xls"
              onChange={e => setFile(e.target.files[0])}
              {...(mode === 'upload' ? { required: true } : {})}
            />
            {mode === 'edit' && <span style={{ fontSize: '0.9em', color: '#888' }}>(Leave blank to keep existing file)</span>}
          </label>
          <div className="modal-actions">
            <button type="submit" disabled={uploading}>{uploading ? (mode === 'edit' ? 'Saving...' : 'Uploading...') : (mode === 'edit' ? 'Save' : 'Upload')}</button>
            <button type="button" onClick={onClose} className="modal-cancel">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
